import "./AboutUsStyles.css";

function AboutUs () {
    return (
        <div className="about-container">
            <h1>Our History</h1>
            <p>Travelo is owned and managed by CodexSuvro, a MERN-stack as well as Blockchain developer. Travelo is counted for its expertise in Trips, and its top notch service providers. Our Invincible expertise and rich experience has raised our spirit to reach ahead from our client's expectation. Commendable success rate of other portals managed by CodexSuvro is a live paradigm of our work excellence.</p>
            <h1>Our Mission</h1>
            <p>Our mission is to touch the horizon where our capabilities may successfully meet with the requirements of our clients, that too with ultimate transparency and cost-effectiveness.</p>
            <h1>Our Vision</h1>
            <p>To sow the seeds of par-excellence services with customer centric approach and reap the trust of worldwide clients.</p>
        </div>
    );
};

export default AboutUs;